import { CommonPipesModule } from 'app/shared/pipes/common-pipes.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { NgModule } from '@angular/core';

import { SharedModule } from 'app/shared/shared.module';
import { BankDetailsComponent } from 'app/entities/caf/bankdetails/bank-details.component';
import { EntityCafComponent } from 'app/entities/caf/entity-caf.component';
import { SummaryDetailsComponent } from 'app/entities/caf/summarydetails/summary-details.component';
import { EntityCafService } from 'app/entities/caf/entity-caf.service';
import { EntitySurveysModule } from 'app/entities/surveys/entity-surveys.module';

@NgModule({
    declarations: [
        BankDetailsComponent,
        EntityCafComponent,
        SummaryDetailsComponent,
    ],
    imports: [
        SharedModule,
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        FlexLayoutModule,
        EntitySurveysModule,
        CommonPipesModule
    ],
    providers: [EntityCafService],
    entryComponents: [],
    exports: [
        EntityCafComponent,
    ]
})
export class EntityCafModule { }



// WEBPACK FOOTER //
// ./src/app/entities/caf/entity-caf.module.ts